import { z } from 'zod';
/** Single error shape for every failed request. `code` is what the client
 *  branches on; `message` is safe to show a parent (never a child). */
export const apiError = z.object({
    code: z.string(),
    message: z.string(),
    details: z.unknown().optional(),
    retryAfterSeconds: z.number().int().optional(),
});
export const ERROR_CODES = {
    badRequest: 'bad_request',
    unauthorised: 'unauthorised',
    forbidden: 'forbidden',
    notFound: 'not_found',
    rateLimited: 'rate_limited',
    internal: 'internal_error',
};
//# sourceMappingURL=errors.js.map